import React from 'react'
import { ReactComponent as PollIcon } from '../../assets/svg/PollIconNew.svg'
import { ReactComponent as QuestionIcon } from '../../assets/svg/QuestionIconNew.svg'
import { ReactComponent as SurveyIcon } from '../../assets/svg/ArchiveSurveyIcon.svg'
import { ReactComponent as JournalIcon } from '../../assets/svg/ArchiveJournalIcon.svg'

// Mirrors the `type` values accepted by GET /api/student/archive.
export const ARCHIVE_FILTERS = ['all', 'mood', 'poll', 'question', 'survey', 'journal']

// Filter chip labels. Kept as a lookup (not template strings) so every key is greppable.
export const FILTER_LABEL_KEYS = {
    all: 'archiveFilterAll',
    mood: 'archiveFilterMoods',
    poll: 'archiveFilterPolls',
    question: 'archiveFilterQuestions',
    survey: 'archiveFilterSurveys',
    journal: 'archiveFilterJournals',
}

// Card label per kind - the same wording the live task cards use, anonymous content included.
export const KIND_LABEL_KEYS = {
    poll: { open: 'open_poll', anonymous: 'anonymous_poll' },
    question: { open: 'open_question', anonymous: 'anonymous_question' },
    survey: { open: 'open_survey', anonymous: 'anonymous_survey' },
    journal: { open: 'archiveKindJournal' },
}

// Accent colours are taken from each type's existing icon gradient so the archive
// reads as the same family as the open task cards.
export const KIND_ACCENT = {
    poll: '#6FCC87',
    question: '#7B7AC7',
    survey: '#F1A716',
    journal: '#AC75B5',
}

const ICONS = {
    poll: PollIcon,
    question: QuestionIcon,
    survey: SurveyIcon,
    journal: JournalIcon,
}

export function KindIcon({ kind, size = 28 }) {
    const Icon = ICONS[kind]
    if (!Icon) return null
    return <Icon width={size} height={size} aria-hidden="true" focusable="false" />
}
